import React from 'react';
import styled from '@emotion/styled';
import { RTCTask } from 'core/models/rtc';
import { Typography } from '@mui/material';

const Frame = styled.div({
    width: '357px',
    height: '340px',
    paddingTop: '36px',

    background: 'rgba(40, 44, 62, 0.7)',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.25)',
    backdropFilter: 'blur(25px)',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const Box = styled.div({
    width: '357px',
    height: '152px',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
});

const Title = styled.div({
    width: '100%',
    height: '18px',

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
});

const TitleText = styled(Typography)({
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: 450,
    fontSize: '15px',
    lineHeight: '120%',
    textAlign: 'center',
    letterSpacing: '0.2em',

    color: '#FFFFFF',
});

const Body = styled.div({
    width: '100%',

    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
});

const DistanceText = styled(Typography)({
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '100px',
    lineHeight: '120%',
    textAlign: 'center',

    color: '#FFFFFF',
});

const UnitText = styled(Typography)({
    fontFamily: 'Futura PT',
    fontStyle: 'normal',
    fontWeight: 450,
    fontSize: '40px',
    lineHeight: '120%',
    textAlign: 'center',
    letterSpacing: '0.2em',

    color: '#FFFFFF',
});

export type RTCInfoPanelProps = {
    className?: string;
    task?: RTCTask;
};

export function RTCInfoPanel(props: RTCInfoPanelProps) {
    const { className, task } = props;

    const speed = task ? task.startDistance.toFixed(1) : undefined;

    return (
        <Frame className={className}>
            <Box>
                <Title>
                    <TitleText>NEXT RTC</TitleText>
                </Title>
                <Body>
                    <UnitText sx={{ marginLeft: '54px', visibility: 'hidden' }}>m</UnitText>
                    <DistanceText>{speed ?? '?'}</DistanceText>
                    <UnitText sx={{ marginRight: '54px' }}>m</UnitText>
                </Body>
            </Box>
        </Frame >
    );
}
